<div
  class="custom-loader"
  [ngStyle]="{ position: overParent ? 'absolute' : 'relative' }">
  <img class="loading-image" src="assets/img/spinner-avla.gif" alt="Loading..." />
</div>
